import type { SiteAlias } from '../../../schema/webshop-package'
import type { JobPostingPackage } from '../../reducers/packages/packages'

import listsAreEqual from '../../../util/lists-are-equal/listsAreEqual'
import { isJobPosting } from './getUpgradesByJobPosting'
import { WebshopPackage } from '../../../schema/webshop-package'

const getJobPostingsBySites = (
  selectedSites: SiteAlias[],
  suggestiblePackages: WebshopPackage[],
): JobPostingPackage[] =>
  suggestiblePackages
    .filter(isJobPosting)
    .reduce(
      (acc, val: WebshopPackage): JobPostingPackage[] =>
        ((val as JobPostingPackage).jobPosting
        && listsAreEqual(selectedSites, (val as JobPostingPackage).jobPosting.publishOn)
          ? [...acc, val as JobPostingPackage]
          : acc),
      [],
    )

export default getJobPostingsBySites
